export enum UnitRole {
  MEMBER = 'member',
  RESIDENT = 'resident',
  TENANT = 'tenant',
  RELATIVE = 'relative',
  PROPERTY_MANAGER = 'propertymanager',
  CUSTOMER_REPRESENTATIVE = 'customer-rep',
  OTHER = 'other',
}
